<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Select Survey
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form @submit.prevent="save()">
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <b-form-group :label-cols="4"
                          label="Surveys"
                          :state="stateForField('survey')"
                          :invalid-feedback="errorForField('survey')"
                          label-class="text-right">
              <b-dropdown menu-class="dropdown-container" :text="surveySetName"
                          :variant="hasError('providerId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item v-for="set in estimateSurveySets" :key="set.organizationEstimateSurveySetId"
                                 @click.prevent="setEstimateSurveySet(set)">{{ set.name }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Save
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>

  import api from '../services/api'
  import ErrorsMixin from '../mixins/ErrorsMixin.js'
  import _ from 'lodash'

  export default {
    name: 'SelectSurveyModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      estimateId: {
        type: Number,
        required: false
      },
      estimateSurveySet: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        estimateSurveySets: [],
        isSaving: false,
        patientEstimateId: 0,
        surveySetName: 'Click to select',
        chosenEstimateSurveySetId: 0
      }
    },

    watch: {
      visible () {
        this.patientEstimateId = _.clone(this.estimateId)
        if (this.estimateSurveySet !== null) {
          this.surveySetName = _.clone(this.estimateSurveySet.name)
        } else {
          this.surveySetName = 'Click to select'
        }
        this.loadData()
      }
    },

    methods: {
      closeModal () {
        this.$emit('update:visible', false)
      },

      loadData () {
        api.get('Dashboard/Estimate/' + this.patientEstimateId + '/EstimateSurveySets').then(response => {
          this.estimateSurveySets = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to load code survey sets: ' + error.message, error)
          }
        })
      },

      validate () {
        this.clearAllErrors()

        if (!this.chosenEstimateSurveySetId > 0) {
          this.addErrorForField('survey', 'You must select a survey')
        }
        return !this.hasErrors()
      },

      setEstimateSurveySet (set) {
        this.chosenEstimateSurveySetId = set.organizationEstimateSurveySetId
        this.surveySetName = set.name
      },

      save () {
        console.log('save')
        if (this.isSaving) {
          return
        }

        if (!this.validate()) {
          return
        }

        this.isSaving = true
        this.errorMessage = ''

        api.post('Dashboard/Estimate/' + this.patientEstimateId + '/SurveySet/' + this.chosenEstimateSurveySetId).then(() => {
          this.$emit('updated')
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to add estimate: ' + error.message, error)
          }
        })
        this.isSaving = false
      }
    }
  }
</script>
